<script>
import NewForm from './New'

export default {
  mixins: [NewForm],
  data() {
    return {
      title: '編集',
    }
  },
  methods: {
    load() {
      this.$http
        .get(`/shipping-advices/${this.$route.query.id}?view=B0401`)
        .then((res) => {
          this.sa = res.data
          console.log(this.sa.packages)
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    doSave() {
      this.$http
        .put('/shipping-advices/update-booking-sa', this.sa)
        .then((res) => {
          if (this.canSendDirectly) {
            var content = '納入指示画面へ遷移しますか。'
            var path = '/B0600'
            if (res.data.allNeedReserve) {
              content = '倉庫別予約一覧へ遷移しますか。'
              path = '/B2300'
            }
            this.$confirm({
              content: content,
              rejectAction: 'いいえ',
            })
              .then(() => {
                return this.$http
                  .put(`shipping-advices/booking-sa-send/${res.data.id}`)
                  .then(() => {
                    this.$message('', 'Success')
                    this.$router.push({
                      path: path,
                      query: {
                        blNo: res.data.blNo,
                      },
                    })
                  })
                  .catch((err) => {
                    this.$showError(err)
                  })
              })
              .catch(() => {
                this.edit(res.data.id)
                this.$message('', 'success')
              })
          } else {
            this.edit(res.data.id)
            this.$message('', 'success')
          }
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    save() {
      if (this.$refs.form.validate() && this.checkPackageData()) {
        if (this.isBooking || this.isBookingBs) {
          this.sa.packages
            .filter((p) => !p.containerNo)
            .forEach((pkg) => {
              pkg.containerNo = '9999999999'
            })
        }

        this.$http
          .put('/shipping-advices/check-sys-bl-if-exist', this.sa)
          .then((r) => {
            if ('COMPLETE' === r.data) {
              this.$message(
                'Error',
                '当該仮予約データに対して正式データが存在しているので、二重登録しないてください。'
              )
              return
            } else if ('PART' === r.data) {
              this.$confirm({
                content:
                  '当該仮予約データのBL.No/コンテナNoと類似する正式データが存在しているので、二重登録を防ぐために、ご確認の上で、ご登録お願い致します。',
              }).then(() => {
                this.doSave()
              })
            } else {
              this.doSave()
            }
          })
      }
    },
  },
  mounted() {
    this.load()
  },
}
</script>
